import { QuotationResponseDto } from "../shared/dtos/quotation/QuotationResponseDto";
import { QuotationSummaryDto } from "../shared/dtos/quotation/QuotationSummaryDto";

export class QuotationMapper {
  public static mapQuotationToSummary(
    quote: QuotationResponseDto,
  ): QuotationSummaryDto {
    return {
      id: quote.id,
      quoteNumber: quote.quoteNumber,
      issueDate: quote.issueDate,
      expiryDate: quote.expiryDate,
      status: quote.status,
      customerName: quote.customerName,
      currencyCode: quote.currencyCode,
      exchangeRate: quote.exchangeRate,
      subtotal: quote.subtotal,
      totalDiscount: quote.totalDiscount,
      total: quote.total,
      totalTaxableAmount: quote.totalTaxableAmount,
      totalTax: quote.totalTax,
      convertedToInvoiceId: quote.convertedToInvoiceId,
    };
  }
}
